import React, { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import FilterHeader from './FilterHeader'
import { useAuth } from '../../../context/API_Client';
import KpiCard from './KpiCard';
import { isEmpty, PAGE_LIST } from '../../utils/utils';
import BoxPayGrid from '../../BoxPayGrid';
import { DashboardTableSchema } from './DashboardTableSchema';
import GenericReconContext from '../../../context/genericRecon.context';
import LoadingLogoPage from '../../loadingPage/loadingPage';
import { customToast } from '../../../reusableComponents/customToaster/customToast';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const KPI_CARD_TOOL_TIP = {
    master_file_count: "Total number of output records from the MIS files after they have been transformed, merged, and processed.",
    insurer_statement_count: "Total number of output records from the Insurer Statement files after they have been transformed, merged, and processed.",
    master_file_amount: "Total aggregated amount of output records from the MIS files after they have been transformed, merged, and processed.",
    insurer_statement_amount: "Total aggregated amount of output records from the Insurer Statement files after they have been transformed, merged, and processed.",
    delta: "Total aggregated delta for all the records."
}

const Dashboard = ({ operationPermissions }) => {
    const {
        selectedFilters,
        selectedTags,
        startDate,
        endDate,
    } = useContext(GenericReconContext);
    const { reconId } = useParams();
    const { getGenericReconciliationVisualizationData } = useAuth();
    const [dashboardData, setDashboardData] = useState();
    const [loaderForTableData, setLoaderForTableData] = useState(true);
    const [kpiData, setKpiData] = useState([{}, {}, {}, {}]);
    const [dashBoardTitle, setDashBoardTitle] = useState([])
    const [currentReconId, setCurrentReconId] = useState("")

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
    const [totalDataCount, setTotalDataCount] = useState(100);
    const [buttonLoader, setButtonLoader] = useState(false)
    const wrapperRef = useRef(null);
    const entityName = "generic_recon_output_records"

    // pagination

    const handleDashboardData = (d) => {

        let tableData = d.map(m => {
            let fileTypeWiseReconData = [...m.fileTypeWiseReconData];
            let delta = m.difference
            delete m.fileTypeWiseReconData;
            fileTypeWiseReconData.map(item => {
                m[`${item.fileTypeTitle} Count`] = item.count
            });
            fileTypeWiseReconData.map(item => {
                m[`${item.fileTypeTitle} Amount`] = item.reconValue
            });

            return { ...m, delta }
        })
        setDashboardData(tableData);
        setLoaderForTableData(false);
    }

    const captureAndDownload = async () => {
        if (!wrapperRef.current) return;
        try {
            setButtonLoader(true)
            const canvas = await html2canvas(wrapperRef.current, {
                scale: 1.5,
                backgroundColor: null,
                useCORS: true,
                ignoreElements: (element) =>
                    element.classList.contains("exclude-from-screenshot") // Exclude elements with this class
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4", true);
            // Define PDF width (A4 width is 210mm)
            const padding = 10;
            const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            // Maintain aspect ratio
            const pdfHeight = (imgHeight * pdfWidth) / imgWidth;
            // Adjust page height dynamically based on content
            pdf.internal.pageSize.height = pdfHeight + 2 * padding;
            // Add image at full width
            pdf.addImage(imgData, "PNG", padding, padding, pdfWidth, pdfHeight);
            pdf.save("dashboard-data.pdf");
            setButtonLoader(false)
        } catch (error) {
            setButtonLoader(false)
            console.error("Error capturing element:", error);
        }
    };


    useEffect(() => {
        setLoaderForTableData(true)
        let toDate = new Date();
        toDate.setHours(23, 59, 59, 999);
        let fromDate = new Date(toDate);
        fromDate.setMonth(fromDate.getMonth() - 13);
        fromDate.setHours(0, 0, 0, 0);
        let filterObj = {};
        if (!isEmpty(selectedFilters)) {
            selectedFilters.forEach(d => {
                const key = `fields.${d.field}`
                if (isEmpty(filterObj[key])) {
                    filterObj[key] = [d.fieldValue]
                } else {
                    filterObj[key].push(d.fieldValue)
                }
            });
        }
        let req = {
            fromDate: startDate || fromDate,
            toDate: endDate || toDate,
            limit: 1000,
            offset: 0,
            attributeFilters: {},
            advancedAttributeFilters: []
        };
        if (!isEmpty(filterObj)) {
            Object.entries(filterObj).forEach(([key, value]) => {
                req.attributeFilters[key] = value;
            })
        }
        if (!isEmpty(selectedTags)) {
            req.attributeFilters.tags = [...selectedTags];
        }

        // DASHBOARD DATA
        getGenericReconciliationVisualizationData(`${entityName}/metrics`,
            reconId,
            { ...req },
            handleSuccessData,
            handleErrorData
        )
        function handleSuccessData(resp) {
            if (currentReconId !== reconId) {
                setCurrentReconId(reconId)
                setDashBoardTitle(Object.keys(resp[0]))
            }
            setDashboardData(resp);
            setLoaderForTableData(false);
        }
        function handleErrorData(err) {
            customToast("error", "high", err);
        }

        //KPIS
        getGenericReconciliationVisualizationData(`${entityName}/key-metrics`,
            reconId,
            { ...req },
            handleSuccessKpisData,
            handleErrorKpisData
        )
        function handleSuccessKpisData(resp) {
            if (resp?.length) {
                const [data] = resp
                const { reconId, ...rest } = data
                const temData = []
                Object.keys(rest).forEach((el, index) => {
                    temData.push({
                        title: el,
                        value: rest[el],
                        seq: index
                    })
                })
                setKpiData(temData)
            }
            // setKpiData
        }
        function handleErrorKpisData(err) {
            customToast("error", "high", err);
        }
    }, [selectedFilters, selectedTags, startDate, endDate, reconId])

    console.log('dashboardData?.length ', dashboardData?.length);

    return (
        <div ref={wrapperRef} className='p-2'>

            <FilterHeader downloadAction={captureAndDownload} buttonLoader={buttonLoader} entityName={entityName} />
            <>
                <div className='kpi-card d-flex'>
                    {
                        kpiData.map((d, i) => (
                            <KpiCard key={i} title={d.title} amount={d.value} toolTip={d.toolTip} />
                        ))
                    }
                </div>

                <div className='tableData'>
                    {
                        dashboardData === undefined || loaderForTableData ? (
                            <LoadingLogoPage />
                        ) : (
                            <BoxPayGrid
                                schema={DashboardTableSchema({ operationPermissions, dashBoardTitle })}
                                data={dashboardData}
                                loader={loaderForTableData}
                                customPagination={false}
                                showCustomizeButton={dashBoardTitle?.length > 6}
                            // pageNo={pageNo}
                            // setPageNo={setPageNo}
                            // pageLimit={pageLimit}
                            // setPageLimit={setPageLimit}
                            // totalDataCount={10}
                            />
                        )
                    }
                </div>
            </>
        </div>
    )
}

export default Dashboard